/**
 * @generated SignedSource<<8ffa55e1e4695426cf7ee045e5647393>>
 * @relayHash c04118226e38d60c4c5613494df4e86d
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 122e616c61c9376523ffce49d21b3b7537dd290f21a188edb4e15b568c1f46f9

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateMyLocationInput = {
  city?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  country?: string | null | undefined;
  latitude?: number | null | undefined;
  longitude?: number | null | undefined;
};
export type ProviderUpdateMyLocationMutation$variables = {
  input: UpdateMyLocationInput;
};
export type ProviderUpdateMyLocationMutation$data = {
  readonly updateMyLocation: {
    readonly user: {
      readonly id: string;
      readonly userLocation: {
        readonly city: string | null | undefined;
        readonly country: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ProviderUpdateMyLocationMutation = {
  response: ProviderUpdateMyLocationMutation$data;
  variables: ProviderUpdateMyLocationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "country",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProviderUpdateMyLocationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateMyLocationPayload",
        "kind": "LinkedField",
        "name": "updateMyLocation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserLocation",
                "kind": "LinkedField",
                "name": "userLocation",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProviderUpdateMyLocationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateMyLocationPayload",
        "kind": "LinkedField",
        "name": "updateMyLocation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserLocation",
                "kind": "LinkedField",
                "name": "userLocation",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "122e616c61c9376523ffce49d21b3b7537dd290f21a188edb4e15b568c1f46f9",
    "metadata": {},
    "name": "ProviderUpdateMyLocationMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "824465b77298c0601400da076abb4c44";

export default node;
